export default {
    SUBSOLAGEM: 'Preparo do solo (subsolagem)',
    CORRETIVO: 'Corretivo',
    ADUBACAO_NITROGENADA: 'Adubação de cobertura (nitrogenada)',
    ADUBACAO_POTASSICA: 'Adubação de cobertura (potássica)',
    PLANTIO_E_IRRIGACAO: 'Plantio e irrigação',
    CONTROLE_DE_FORMIGAS: 'Controle de formigas',
    MATOCOMPETICAO: 'Matocompetição'
}